import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const resizeHandleStyles: IStyles = {
    handle: {
        position: 'absolute',
        width: 8,
        height: 8,
        background: color.bgWhitePrimary,
        border: `1px solid ${color.blue}`,
        borderRadius: 1,
        boxSizing: 'border-box',
        zIndex: 2,
    },
    nw: { top: -4, left: -4, cursor: 'nwse-resize' },
    n: { top: -4, left: '50%', marginLeft: -4, cursor: 'ns-resize' },
    ne: { top: -4, right: -4, cursor: 'nesw-resize' },
    e: { top: '50%', right: -4, marginTop: -4, cursor: 'ew-resize' },
    se: { bottom: -4, right: -4, cursor: 'nwse-resize' },
    s: { bottom: -4, left: '50%', marginLeft: -4, cursor: 'ns-resize' },
    sw: { bottom: -4, left: -4, cursor: 'nesw-resize' },
    w: { top: '50%', left: -4, marginTop: -4, cursor: 'ew-resize' },
}

addStyles(resizeHandleStyles)
export default resizeHandleStyles
